<template>
    <div class="mt-2">
        <div v-if="movies.length" class="flex flex-col gap-2">
            <div
                v-for="movie in movies.slice(0, count)"
                :key="movie.id"
                class="home-movie-row flex items-start gap-3 rounded border border-slate-700/40 bg-slate-900/30 overflow-hidden p-2"
                itemscope
                itemtype="http://schema.org/Movie"
            >
                <div class="min-w-0 flex-1">
                    <div class="flex items-start justify-between gap-2">
                        <h3 class="text-sm font-semibold text-slate-100 leading-tight" itemprop="name">
                            {{ movie.title }}
                        </h3>
                        <span class="text-xs text-slate-400 shrink-0">{{ movie.year }}</span>
                    </div>
                    <div class="flex items-center gap-2 mt-0.5">
                        <span class="text-xs text-slate-300" itemprop="datePublished">
                            {{ formatDate(movie.release_date, 'MMM D, YYYY') }}
                        </span>
                        <span
                            class="text-xs px-1.5 py-px rounded-full uppercase tracking-wide"
                            :class="movie.status === 'released' ? 'text-slate-400' : 'text-green-400'"
                        >
                            {{ convertStatus(movie.status) }}
                        </span>
                    </div>
                    <p v-if="movie.genres" class="text-xs text-slate-400 truncate mt-0.5">{{ movie.genres }}</p>
                </div>
            </div>
        </div>
        <div v-else class="w-full h-24 flex flex-wrap justify-center items-center text-center text-slate-400">
            No Upcoming Movies. Check Back Soon!
        </div>
    </div>
</template>

<script>
    import { convertStatus, formatDate } from '@/utils/Utilities';
    import { gsap } from 'gsap/all'

    export default {
        name: 'HomeUpcomingMovies',
        props: {
            movies: {
                type: Array,
                default: () => [],
            },
            count: {
                type: Number,
                default: 5,
            },
        },
        mounted() {
            gsap.fromTo('.home-movie-row',
                { y: 10, opacity: 0 },
                { y: 0, opacity: 1, stagger: .03, duration: .25 },
            )
        },
        methods: {
            convertStatus,
            formatDate,
        },
    }
</script>

<style lang="postcss">
.home-movie-row {
    opacity: 0;
}
</style>
